import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { UserContext } from '../../../Application';
import AdminTable from '../AdminTable';
import { MODELS } from '../../../constants/admin/settings';
import { openModalForm } from '../../../actions/admin/modal.forms';
import AdminModalForm from '../AdminModalForm';
import SignState from '../../../components/application/contracts/SignState';
import EventArtistInputs from '../../../components/admin/lineup/EventArtistInputs';
import {
    fetchEventArtistDependencies,
    fetchEventArtistsWithContractStatus,
    openEventArtist,
    createEventArtist,
    deleteEventArtists
} from '../../../actions/admin/models/event.artists';
import { hasPermissions, PERMISSIONS } from '../../../constants/authentication/permissions';
import { PER_PAGE_OPTION_2 } from '../../../constants/admin/tables';

class EventArtists extends Component {
    _transformRows = {
        contract: (s) => <SignState state={s} />
    };
    _deleteEventArtists = () => this.props.deleteEventArtists(this.props.eventId);
    render() {
        return (
            <UserContext.Consumer>
                {user => (
                    <React.Fragment>
                        <AdminTable
                            openItem={
                                hasPermissions(user, PERMISSIONS.ARTISTS_VIEW) ? this.props.openEventArtist : null
                            }
                            buttonAction={this.props.openModalForm}
                            subContextId={this.props.eventId}
                            model={MODELS.EVENT_ARTIST}
                            pagination={true}
                            fetchDataFunction={this.props.fetchEventArtistsWithContractStatus}
                            deleteAction={this._deleteEventArtists}
                            forceInitialPages={PER_PAGE_OPTION_2}
                            transformFunctions={this._transformRows}
                        />
                        <AdminModalForm
                            model={MODELS.EVENT_ARTIST}
                            title="Add Artist to Event"
                            modelId={this.props.eventId}
                            fields={EventArtistInputs}
                            fetchDependencies={this.props.fetchEventArtistDependencies}
                            createAction={this.props.createEventArtist}
                        />
                    </React.Fragment>
                )}
            </UserContext.Consumer>
        );
    }
}

const mapStateToProps = state => ({});

const mapDispatchToProps = dispatch =>
    bindActionCreators(
        {
            openModalForm,
            fetchEventArtistsWithContractStatus,
            fetchEventArtistDependencies,
            deleteEventArtists,
            createEventArtist,
            openEventArtist
        },
        dispatch
    );

export default connect(mapStateToProps, mapDispatchToProps)(EventArtists);



// WEBPACK FOOTER //
// ./src/containers/admin/events/EventArtists.js